<script>
// no <template>: trix-editor is a custom element and compile-time
// isCustomElement doesn't survive thread-loader (function options are
// dropped when serialized to workers); h() with a string tag needs no
// component resolution at all
import { h } from 'vue';
import Trix from 'trix';
import 'trix/dist/trix.css';

let uid = 0;

export default {
    name: 'Wysiwyg',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            inputId: `wysiwyg-input-${++uid}`
        };
    },
    mounted() {
        if (Trix.config.textAttributes.underline instanceof Object) return;

        Trix.config.textAttributes.underline = {
            style: { textDecoration: 'underline' },
            inheritable: true,
            parser: function(element) {
                var style = window.getComputedStyle(element);
                return style.textDecoration === 'underline';
            }
        };

        document.addEventListener('trix-initialize', function(e) {
            const trix = e.target;
            const toolBar = trix.toolbarElement;

            const button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.setAttribute(
                'class',
                'trix-button trix-button--icon trix-button--icon-underline'
            );
            button.setAttribute('data-trix-attribute', 'underline');
            button.setAttribute('title', 'underline');
            button.setAttribute('tabindex', '-1');
            button.innerText = 'U';

            toolBar.querySelector('.trix-button-group--text-tools').appendChild(button);
        });
    },
    render() {
        return h('div', { class: 'wysiwyg' }, [
            h('input', { id: this.inputId, type: 'hidden', value: this.modelValue }),
            h('trix-editor', {
                ref: 'editor',
                input: this.inputId,
                placeholder: this.placeholder,
                onTrixChange: this.onChange
            })
        ]);
    },
    methods: {
        onChange(e) {
            this.$emit('update:modelValue', e.target.value);
        },
        clear() {
            this.$refs.editor.editor.loadHTML('');
            this.$emit('update:modelValue', '');
        }
    }
};
</script>

<style lang="scss" src="./Wysiwyg.scss"></style>
